import React from 'react';
import SimpleHero from '../../components/SimpleHero/SimpleHero';
import FeatureList from '../../components/Minimal/FeatureList';
import personal from "../../assets/images/ploan.png";
import car from "../../assets/images/car.png";
import home from "../../assets/images/home.png";

const Loans= () => {
  return (
    <div>
      <SimpleHero
        title="Borrow , with clear terms"
        subtitle="Personal, auto, and home loans with competitive rates and guidance from our team."
        primaryLabel="Apply now"
        primaryHref="/loans"
        align="center"
        variant="sofi"
        imageSrc={personal}
        imageAlt="Loans preview"
        imageOn="right"
        tiltImage
        badges={["Personal","Auto","Home"]}
      />
      <FeatureList
        items={[
          { icon: personal, title: 'Personal loans', desc: 'Flexible funds for life’s needs.' },
          { icon: car, title: 'Auto loans', desc: 'Finance a new or used car with ease.' },
          { icon: home, title: 'Home loans', desc: 'Make home happen with smart financing.' },
        ]}
      />
      <section className="section text-center">
        <div className="gn-container">
          <a className="btn btn-gn-primary" href="/contact">Talk to a loan officer</a>
        </div>
      </section>
    </div>
  );
};

export default Loans;

